export default "__VITE_ASSET__YjCe4bmM__"